import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import Dropzone from 'react-dropzone'
import log from 'lib/log'
import Avatar from 'components/Avatar'
import { appContextType } from 'App'
import styles from './AvatarField.css'
import styled from 'styled-components'

const mime_types = [
  'image/png',
  'image/jpg',
  'image/jpe',
  'image/jpeg',
  'image/webp'
]
const mime_types_as_comma_delimited_list = mime_types.join(',')

function getCoordinatesForPercent(percent) {
  const p = percent / 100
  const x = Math.cos(2 * Math.PI * p)
  const y = Math.sin(2 * Math.PI * p)
  return { x, y }
}

function segment(percent) {
  const start = getCoordinatesForPercent(percent)
  const end = getCoordinatesForPercent(100)
  return [
    `M ${start.x} ${start.y}`, // Move
    `A 1 1, 0, ${100 - percent > 50 ? 1 : 0}, 1, ${end.x} ${end.y}`, // Arc
    `L 0 0` // Line
  ].join(' ')
}

function cleanUpPreview(file) {
  try {
    if (file && file.preview) window.URL.revokeObjectURL(file.preview)
  } catch (err) {
    log.error(err)
  }
}

class AvatarField extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleDrop = this.handleDrop.bind(this)
    this.onProgress = this.onProgress.bind(this)
    this.onUploadSuccess = this.onUploadSuccess.bind(this)
    this.onUploadError = this.onUploadError.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }
  async handleDrop(accepted, rejected) {
    if (accepted.length) {
      const file = accepted[0]
      try {
        const { input: { onChange } } = this.props
        onChange({
          file,
          progress: 0
        })
        const result = await this.context.api.upload({
          file,
          onProgress: this.onProgress
        })
        this.onUploadSuccess(result[0])
      } catch (err) {
        this.onUploadError(err)
      }
    }
  }
  onProgress(progress) {
    const { input: { onChange, value: { file } } } = this.props
    onChange({
      file,
      progress
    })
  }
  onUploadSuccess(result) {
    const { input: { onChange, value: { file } } } = this.props
    if (onChange) {
      onChange(result)
      setTimeout(() => {
        cleanUpPreview(file)
      }, 0)
    }
  }
  onUploadError(err) {
    const { input: { onChange, value: { file } } } = this.props
    if (onChange) {
      onChange({
        error: err
      })
      setTimeout(() => {
        cleanUpPreview(file)
      }, 0)
    }
  }
  componentWillUnmount() {
    // clean up the preview ...
    const { input: { value: { file } } } = this.props
    if (file) {
      cleanUpPreview(file)
    }
  }
  renderContent() {
    const { input: { value } } = this.props

    if (value?.file) {
      return (
        <div className={styles.upload}>
          <img src={value.file.preview} />
          <svg viewBox="-1 -1 2 2" style={{ transform: 'rotate(-0.25turn)' }}>
            <path d={segment(value.progress)} fill="#43a047" opacity={0.5} />
          </svg>
        </div>
      )
    }

    return <Avatar avatar={value?.error ? {} : value} size={192} />
  }
  render() {
    const { upload: { error } = {} } = this.state
    const { showLabel = true, username } = this.props
    return (
      <Dropzone
        accept={mime_types_as_comma_delimited_list}
        onDrop={this.handleDrop}
      >{({ getRootProps, getInputProps }) => (
        <div {...getRootProps()} className={styles.avatar_dropzone}>
          <input {...getInputProps()} />
          {this.renderContent()}
          <AvatarLabel showLabel={showLabel} error={error} username={username} />
        </div>
      )}
      </Dropzone>
    )
  }
}

const UserNameWrapper = styled.div`
  color: black;
  font-size: 1.5em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const AvatarUserName = ({ username }) => {
  if (!username) {
    return null
  }
  return <UserNameWrapper>{username}</UserNameWrapper>
}

const AvatarLabel = ({ showLabel, error, username }) => {
  return (
    <div>
      <AvatarUserName username={username} />
      {showLabel && (
        <span>
          <FormattedMessage id="profile.choose_avatar_label" />
          {error ? (
            <FormattedMessage id={`profile.${error.message}`} />
          ) : null}
        </span>
      )}
    </div>
  )
}

AvatarField.contextTypes = appContextType

export default AvatarField
